import React from "react";
import emailjs from "@emailjs/browser";

export default function ModalReservaTour({ data, onClose }) {
    const handleConfirm = () => {
        const templateParams = {
            title: 'RESERVACIÓN DE TOUR',
            fullName: data.fullName,
            phone: data.phone,
            email: data.email,
            package: data.package,
            numberOfPeople: data.numberOfPeople,
            tourDate: data.tourDate,
            paymentMethod: data.paymentMethod,
        };

        emailjs
            .send(
                "service_1mhkq3p",       // Reemplaza con tu Service ID
                "template_yatezi5",      // Reemplaza con tu Template ID
                templateParams,
                "yqswG38nVxaWBINOV"        // Reemplaza con tu Public Key
            )
            .then(
                (response) => {
                    alert("¡Reservación enviada correctamente!");
                    onClose();
                    window.location.href = '/';
                },
                (error) => {
                    alert("Error al enviar la reservación.");
                    console.error(error);
                }
            );
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg p-8 max-w-5xl w-full my-10 max-h-[80vh] overflow-y-auto">
                <h2 className="text-2xl font-bold mb-4 text-primary-800">Confirmar reservación</h2>
                <div className="text-primary-800 space-y-2 mb-4">
                    <p><strong>Nombre Completo:</strong> {data.fullName}</p>
                    <p><strong>Teléfono:</strong> {data.phone}</p>
                    <p><strong>Correo Electrónico:</strong> {data.email}</p>
                    <p><strong>Tour Seleccionado:</strong> {data.package}</p>
                    <p><strong>Número de Personas:</strong> {data.numberOfPeople}</p>
                    <p><strong>Fecha del Tour:</strong> {data.tourDate}</p>
                    <p><strong>Método de Pago:</strong> {data.paymentMethod}</p>
                </div>

                

                {data.paymentMethod === "Billetera_digital" && (
                    <div className="mb-4 grid grid-cols-1 md:grid-cols-2 place-items-center gap-4">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/yape_imagen.webp`}
                            className="w-full md:w-[40%] rounded-lg"
                            alt="Yape"
                        />
                        <div className="border-2 border-primary-800 p-4 rounded-lg">
                            <p className="mb-2 font-semibold">
                            Nota: Para completar la reservación, es importante seguir los siguientes pasos:
                            </p>
                            <ul className="list-disc list-inside space-y-1 leading-relaxed">
                            <li>Realizar la transferencia del monto correspondiente según el servicio elegido.</li>
                            <li>
                                Enviar el comprobante de pago a través del siguiente enlace:{' '}
                                <a
                                href="https://api.whatsapp.com/send?phone=51993119862&text=Deseo%20Realizar%20un%20pago%20para%20reservar"
                                className="text-blue-600 underline"
                                target="_blank"
                                rel="noopener noreferrer"
                                >
                                https://whatsapp_pagos.com
                                </a>
                            </li>
                            <li>
                                Terminado el paso anterior dar clic en <strong>Confirmar</strong>
                            </li>
                            </ul>
                        </div>
                    </div>
                )}

                {data.paymentMethod === "Transferencia_bancaria" && (
                    <div className="mb-4 grid grid-cols-1 md:grid-cols-2 place-items-center gap-4">
                        <img
                            src={`${process.env.PUBLIC_URL}/images/bcp_cuenta.png`}
                            className="w-full md:w-[40%] rounded-lg"
                            alt="CUENTAS"
                        />
                        <div className="border-2 border-primary-800 p-4 rounded-lg">
                            <p className="mb-2 font-semibold">
                            Nota: Para completar la reservación, es importante seguir los siguientes pasos:
                            </p>
                            <ul className="list-disc list-inside space-y-1 leading-relaxed">
                            <li>Realizar la transferencia del monto correspondiente según el servicio elegido.</li>
                            <li>
                                Enviar el comprobante de pago a través del siguiente enlace:{' '}
                                <a
                                href="https://api.whatsapp.com/send?phone=51993119862&text=Deseo%20Realizar%20un%20pago%20para%20reservar"
                                className="text-blue-600 underline"
                                target="_blank"
                                rel="noopener noreferrer"
                                >
                                https://whatsapp_pagos.com
                                </a>
                            </li>
                            <li>
                                Terminado el paso anterior dar clic en <strong>Confirmar</strong>
                            </li>
                            </ul>
                        </div>
                    </div>
                    
                )}

                

                <div className="mt-4 flex justify-between">
                    <button
                        className="px-4 py-2 bg-red-700 text-white rounded"
                        onClick={onClose}
                    >
                        Cerrar
                    </button>
                    <button
                        className="px-4 py-2 bg-green-800 text-white rounded"
                        onClick={handleConfirm}
                    >
                        Confirmar
                    </button>
                </div>
            </div>
        </div>
    );
}
